import React from 'react'
import { Box, Button, Stack, Typography, useTheme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import CheckIcon from '@mui/icons-material/Check'
import { useIntl } from 'react-intl'

interface ConnectionSummaryStepProps {
  connectedCount: number
  onClose: () => void
}

const ConnectionSummaryStep: React.FC<ConnectionSummaryStepProps> = ({ onClose }) => {
  const { formatMessage } = useIntl()
  const theme = useTheme()

  return (
    <Stack alignItems="center" justifyContent="center" spacing={0} sx={{ height: '100vh' }}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          width: 96,
          height: 96,
          borderRadius: '50%',
          backgroundColor: theme.palette.success.main,
        }}
      >
        <CheckIcon sx={{ color: theme.palette.text.primary, fontSize: 64 }} />
      </Box>
      <Box mt={3} />
      <Typography variant="h6" fontWeight={600} align="center" color="text.primary">
        {formatMessage({ id: 'connectOnlyFlowProvidersModal.summary.title' })}
      </Typography>
      <Box mt={3} />
      <Typography color="text.secondary" align="center" sx={{ maxWidth: 488 }}>
        {formatMessage({ id: 'connectOnlyFlowProvidersModal.summary.info' })}
      </Typography>
      <Box mt={4} />
      <Button variant="text" startIcon={<CloseIcon />} onClick={onClose} sx={{ fontWeight: 600 }} color="primary">
        {formatMessage({ id: 'general.close' })}
      </Button>
    </Stack>
  )
}

export default ConnectionSummaryStep
